import { createSlice } from '@reduxjs/toolkit';
import { setUISystemProcessExecutionSearchFilter } from './actions';
import {
  defaultSystemProcessExecutionTableState,
  setSystemProcessExecutionTableState,
  SystemProcessExecutionUIStoreState,
} from '@ots-frontend/ots-ui-tw';

const INITIAL_STATE: Readonly<SystemProcessExecutionUIStoreState> = {
  tableState: defaultSystemProcessExecutionTableState,
};

const systemProcessExecutionUISlice = createSlice({
  name: 'ots-ui/system-process-execution',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUISystemProcessExecutionSearchFilter,
      (state, { payload }) => {
        state.searchFilter = payload;
      }
    );
    builder.addCase(
      setSystemProcessExecutionTableState,
      (state, { payload }) => {
        state.tableState = payload;
      }
    );
  },
});

export const systemProcessExecutionUIReducer =
  systemProcessExecutionUISlice.reducer;
